// Shared species data module
// Extracted from WildlifeMigrationTracker.jsx for use across decomposed components

export const speciesData = {
  birds: [
    {
      id: 'arctic-tern',
      name: 'Arctic Tern',
      scientificName: 'Sterna paradisaea',
      category: 'birds',
      icon: '🕊️',
      image: 'https://images.unsplash.com/photo-1558226008-65875bbfee5e?w=800&h=600&fit=crop',
      gallery: [
        'https://images.unsplash.com/photo-1591608971362-f9bdfe483a8e?w=800&h=600&fit=crop',
        'https://images.unsplash.com/photo-1548550023-2bdb3c5beed7?w=800&h=600&fit=crop',
      ],
      status: 'Least Concern',
      distance: '71,000 km/year',
      description: 'The longest migration of any bird, pole to pole annually.',
      seasons: { depart: 'August', arrive: 'December', return: 'April' },
      tips: 'Best spotted in Arctic regions during summer breeding season.',
      route: [
        { lat: 71.0, lng: -8.0, name: 'Arctic Breeding Grounds' },
        { lat: 55.0, lng: -10.0, name: 'North Atlantic' },
        { lat: 35.0, lng: -20.0, name: 'Canary Current' },
        { lat: 0.0, lng: -25.0, name: 'Equatorial Atlantic' },
        { lat: -35.0, lng: -5.0, name: 'South Atlantic' },
        { lat: -65.0, lng: 0.0, name: 'Antarctic Waters' },
      ],
      color: '#3B82F6'
    },
    {
      id: 'bar-tailed-godwit',
      name: 'Bar-tailed Godwit',
      scientificName: 'Limosa lapponica',
      category: 'birds',
      icon: '🐦',
      image: 'https://images.unsplash.com/photo-1620066799812-244a139c37c8?w=800&h=600&fit=crop',
      gallery: [
        'https://images.unsplash.com/photo-1567573529899-8e01c9e5d77f?w=800&h=600&fit=crop',
        'https://images.unsplash.com/photo-1590003763738-09a3739cd4de?w=800&h=600&fit=crop',
      ],
      status: 'Near Threatened',
      distance: '11,000 km non-stop',
      description: 'Holds the record for longest non-stop flight by any bird.',
      seasons: { depart: 'September', arrive: 'October', return: 'March' },
      tips: 'Watch for massive flocks in New Zealand during southern summer.',
      route: [
        { lat: 64.0, lng: -161.0, name: 'Alaska' },
        { lat: 40.0, lng: -170.0, name: 'North Pacific' },
        { lat: 10.0, lng: -185.0, name: 'Central Pacific' },
        { lat: -20.0, lng: -185.0, name: 'Fiji Region' },
        { lat: -37.0, lng: -185.0, name: 'New Zealand' },
      ],
      color: '#F59E0B'
    },
    {
      id: 'ruby-throated-hummingbird',
      name: 'Ruby-throated Hummingbird',
      scientificName: 'Archilochus colubris',
      category: 'birds',
      icon: '🌺',
      image: 'https://images.unsplash.com/photo-1627092956631-282690fd3752?w=800&h=600&fit=crop',
      gallery: [
        'https://images.unsplash.com/photo-1552727131-5fc6af8e9656?w=800&h=600&fit=crop',
        'https://images.unsplash.com/photo-1592768980083-0770e29de6e9?w=800&h=600&fit=crop',
      ],
      status: 'Least Concern',
      distance: '3,000 km',
      description: 'Tiny but mighty, crosses the Gulf of Mexico non-stop.',
      seasons: { depart: 'September', arrive: 'October', return: 'March' },
      tips: 'Set up feeders in spring to catch their northward journey!',
      route: [
        { lat: 42.0, lng: -85.0, name: 'Eastern USA' },
        { lat: 35.0, lng: -90.0, name: 'Mississippi Valley' },
        { lat: 29.0, lng: -95.0, name: 'Gulf Coast' },
        { lat: 23.0, lng: -90.0, name: 'Gulf of Mexico' },
        { lat: 20.0, lng: -88.0, name: 'Yucatan Peninsula' },
      ],
      color: '#EC4899'
    },
    {
      id: 'osprey',
      name: 'Osprey',
      scientificName: 'Pandion haliaetus',
      category: 'birds',
      icon: '🦅',
      image: 'https://images.unsplash.com/photo-1571483497541-cedd7741252d?w=800&h=600&fit=crop',
      gallery: [
        'https://images.unsplash.com/photo-1611164934921-e63a80c1e2c5?w=800&h=600&fit=crop',
        'https://images.unsplash.com/photo-1575990653399-51bdb35e1a91?w=800&h=600&fit=crop',
      ],
      status: 'Least Concern',
      distance: '6,000 km',
      description: 'Fish-eating raptor with remarkable navigation abilities.',
      seasons: { depart: 'September', arrive: 'November', return: 'March' },
      tips: 'Look near large bodies of water; they dive feet-first for fish.',
      route: [
        { lat: 55.0, lng: -3.0, name: 'Scotland' },
        { lat: 45.0, lng: -1.0, name: 'France' },
        { lat: 35.0, lng: -6.0, name: 'Morocco' },
        { lat: 20.0, lng: -15.0, name: 'Mauritania' },
        { lat: 12.0, lng: -15.0, name: 'Senegal' },
      ],
      color: '#8B5CF6'
    },
    {
      id: 'adelie-penguin',
      name: 'Adélie Penguin',
      scientificName: 'Pygoscelis adeliae',
      category: 'birds',
      icon: '🐧',
      image: 'https://images.unsplash.com/photo-1550064762-4a75f2f90764?w=800&h=600&fit=crop',
      gallery: [
        'https://images.unsplash.com/photo-1516026672322-bc52d61a55d5?w=800&h=600&fit=crop',
        'https://images.unsplash.com/photo-1588776814546-1f7eed0ce5e1?w=800&h=600&fit=crop',
      ],
      status: 'Least Concern',
      distance: '17,600 km',
      description: 'Follows the sun around Antarctica, one of the longest penguin migrations.',
      seasons: { depart: 'March', arrive: 'April', return: 'October' },
      tips: 'Visit Ross Sea region in summer for breeding colonies.',
      route: [
        { lat: -77.5, lng: 166.0, name: 'Ross Island Colonies' },
        { lat: -74.0, lng: 170.0, name: 'Ross Sea' },
        { lat: -68.0, lng: 175.0, name: 'Pacific Antarctic' },
        { lat: -65.0, lng: 190.0, name: 'Winter Feeding Grounds' },
      ],
      color: '#1E3A8A'
    },
    {
      id: 'whooping-crane',
      name: 'Whooping Crane',
      scientificName: 'Grus americana',
      category: 'birds',
      icon: '🦢',
      image: 'https://images.unsplash.com/photo-1696632080239-c07e3f8661b2?w=800&h=600&fit=crop',
      gallery: [
        'https://images.unsplash.com/photo-1609599006353-e629aaabfeae?w=800&h=600&fit=crop',
        'https://images.unsplash.com/photo-1620466084855-e5620d9a04de?w=800&h=600&fit=crop',
      ],
      status: 'Endangered',
      distance: '4,000 km',
      description: 'North America\'s tallest bird, recovered from just 21 individuals in 1941.',
      seasons: { depart: 'September', arrive: 'November', return: 'April' },
      tips: 'Aransas National Wildlife Refuge in Texas for winter viewing.',
      route: [
        { lat: 60.0, lng: -113.0, name: 'Wood Buffalo National Park' },
        { lat: 52.0, lng: -110.0, name: 'Saskatchewan' },
        { lat: 42.0, lng: -100.0, name: 'Nebraska Platte River' },
        { lat: 35.0, lng: -98.0, name: 'Oklahoma' },
        { lat: 28.3, lng: -96.8, name: 'Aransas, Texas' },
      ],
      color: '#DC2626'
    },
    {
      id: 'snow-goose',
      name: 'Snow Goose',
      scientificName: 'Anser caerulescens',
      category: 'birds',
      icon: '🪿',
      image: 'https://images.unsplash.com/photo-1542890810-ef4b60ec8c87?w=800&h=600&fit=crop',
      gallery: [
        'https://images.unsplash.com/photo-1474511320723-9a56873867b5?w=800&h=600&fit=crop',
        'https://images.unsplash.com/photo-1560713781-d1f64e0d0a5f?w=800&h=600&fit=crop',
      ],
      status: 'Least Concern',
      distance: '5,000 km',
      description: 'Massive flocks of white geese in spectacular V-formations.',
      seasons: { depart: 'September', arrive: 'November', return: 'March' },
      tips: 'Bosque del Apache in New Mexico hosts thousands each winter.',
      route: [
        { lat: 73.0, lng: -80.0, name: 'Arctic Canada Breeding' },
        { lat: 60.0, lng: -95.0, name: 'Hudson Bay' },
        { lat: 48.0, lng: -100.0, name: 'Prairie Pothole Region' },
        { lat: 38.0, lng: -95.0, name: 'Central Flyway' },
        { lat: 29.0, lng: -95.0, name: 'Gulf Coast Texas' },
      ],
      color: '#F8FAFC'
    },
    {
      id: 'barn-swallow',
      name: 'Barn Swallow',
      scientificName: 'Hirundo rustica',
      category: 'birds',
      icon: '🐦',
      image: 'https://images.unsplash.com/photo-1639675624162-04158684ce48?w=800&h=600&fit=crop',
      gallery: [
        'https://images.unsplash.com/photo-1605020420620-20c943cc4669?w=800&h=600&fit=crop',
        'https://images.unsplash.com/photo-1570975640538-7fc25fada773?w=800&h=600&fit=crop',
      ],
      status: 'Least Concern',
      distance: '11,000 km',
      description: 'The most widespread swallow species, found on every continent except Antarctica.',
      seasons: { depart: 'August', arrive: 'October', return: 'April' },
      tips: 'Watch for them catching insects over open fields and water.',
      route: [
        { lat: 52.0, lng: 0.0, name: 'UK & Northern Europe' },
        { lat: 40.0, lng: 5.0, name: 'Spain' },
        { lat: 30.0, lng: 0.0, name: 'Sahara Crossing' },
        { lat: 10.0, lng: 5.0, name: 'West Africa' },
        { lat: -25.0, lng: 28.0, name: 'South Africa' },
      ],
      color: '#0369A1'
    },
    {
      id: 'black-necked-crane',
      name: 'Black-necked Crane',
      scientificName: 'Grus nigricollis',
      category: 'birds',
      icon: '🦢',
      image: 'https://images.unsplash.com/photo-1771867723586-f10e12c56969?w=800&h=600&fit=crop',
      gallery: [
        'https://images.unsplash.com/photo-1652872794580-c0d476c1af03?w=800&h=600&fit=crop',
        'https://images.unsplash.com/photo-1598300048855-4e0c4870c4c5?w=800&h=600&fit=crop',
      ],
      status: 'Vulnerable',
      distance: '1,200 km',
      description: 'World\'s only alpine crane, breeding on the Tibetan Plateau.',
      seasons: { depart: 'October', arrive: 'November', return: 'March' },
      tips: 'Phobjikha Valley in Bhutan hosts 500+ cranes each winter.',
      route: [
        { lat: 33.0, lng: 90.0, name: 'Tibetan Plateau Breeding' },
        { lat: 30.0, lng: 92.0, name: 'Central Tibet' },
        { lat: 28.0, lng: 90.0, name: 'Himalayan Crossing' },
        { lat: 27.5, lng: 90.3, name: 'Phobjikha Valley, Bhutan' },
      ],
      color: '#1F2937'
    },
    {
      id: 'lesser-flamingo',
      name: 'Lesser Flamingo',
      scientificName: 'Phoeniconaias minor',
      category: 'birds',
      icon: '🦩',
      image: 'https://images.unsplash.com/photo-1670786445697-e0b6570d2687?w=800&h=600&fit=crop',
      gallery: [
        'https://images.unsplash.com/photo-1559648329-97c64c6bffab?w=800&h=600&fit=crop',
        'https://images.unsplash.com/photo-1497206365907-f5e630693df0?w=800&h=600&fit=crop',
      ],
      status: 'Near Threatened',
      distance: '500 km',
      description: 'Millions gather at East Africa\'s alkaline lakes in spectacular pink clouds.',
      seasons: { depart: 'Variable', arrive: 'Variable', return: 'Variable' },
      tips: 'Lake Nakuru and Lake Bogoria in Kenya for massive flocks.',
      route: [
        { lat: -2.0, lng: 36.0, name: 'Lake Natron (Breeding)' },
        { lat: -0.4, lng: 36.1, name: 'Lake Nakuru' },
        { lat: 0.2, lng: 36.1, name: 'Lake Bogoria' },
        { lat: -1.5, lng: 37.0, name: 'Lake Magadi' },
      ],
      color: '#EC4899'
    },
    {
      id: 'common-swift',
      name: 'Common Swift',
      scientificName: 'Apus apus',
      category: 'birds',
      icon: '🕊️',
      image: 'https://images.unsplash.com/photo-1595674251046-b6c1c09ce9b9?w=800&h=600&fit=crop',
      gallery: [
        'https://images.unsplash.com/photo-1612862257374-d1d2a025e059?w=800&h=600&fit=crop',
        'https://images.unsplash.com/photo-1589802829985-817e51171b92?w=800&h=600&fit=crop',
      ],
      status: 'Least Concern',
      distance: '14,000 km',
      description: 'Spends 10 months airborne without landing - eats, sleeps, and mates in flight!',
      seasons: { depart: 'August', arrive: 'October', return: 'April' },
      tips: 'Look up at dusk in European cities to see their aerial acrobatics.',
      route: [
        { lat: 52.0, lng: 0.0, name: 'Northern Europe Breeding' },
        { lat: 40.0, lng: 0.0, name: 'Iberian Peninsula' },
        { lat: 25.0, lng: 0.0, name: 'Sahara Crossing' },
        { lat: 0.0, lng: 25.0, name: 'Congo Basin' },
        { lat: -15.0, lng: 28.0, name: 'Southern Africa' },
      ],
      color: '#475569'
    },
    {
      id: 'sooty-shearwater',
      name: 'Sooty Shearwater',
      scientificName: 'Ardenna grisea',
      category: 'birds',
      icon: '🐦',
      image: 'https://images.unsplash.com/photo-1636519615146-1bb1953b29b5?w=800&h=600&fit=crop',
      gallery: [
        'https://images.unsplash.com/photo-1567960827069-daa2b2f0edff?w=800&h=600&fit=crop',
        'https://images.unsplash.com/photo-1622017911841-6acf0a2af35b?w=800&h=600&fit=crop',
      ],
      status: 'Near Threatened',
      distance: '64,000 km/year',
      description: 'Longest bird migration - a figure-8 route across the entire Pacific Ocean.',
      seasons: { depart: 'April', arrive: 'June', return: 'October' },
      tips: 'Watch for massive flocks off California and New Zealand coasts.',
      route: [
        { lat: -45.0, lng: 168.0, name: 'New Zealand Breeding' },
        { lat: -30.0, lng: 185.0, name: 'South Pacific' },
        { lat: 0.0, lng: -160.0, name: 'Central Pacific' },
        { lat: 35.0, lng: -125.0, name: 'California Coast' },
        { lat: 50.0, lng: -145.0, name: 'North Pacific' },
        { lat: 35.0, lng: -185.0, name: 'West Pacific Return' },
      ],
      color: '#4B5563'
    },
    {
      id: 'amur-falcon',
      name: 'Amur Falcon',
      scientificName: 'Falco amurensis',
      category: 'birds',
      icon: '🦅',
      image: 'https://images.unsplash.com/photo-1663277827855-17f8285e86e5?w=800&h=600&fit=crop',
      gallery: [
        'https://images.unsplash.com/photo-1550159930-40066082a4fc?w=800&h=600&fit=crop',
        'https://images.unsplash.com/photo-1543940434-fa30f2e5eef8?w=800&h=600&fit=crop',
      ],
      status: 'Least Concern',
      distance: '22,000 km/year',
      description: 'Longest ocean crossing of any raptor - 3,150 km non-stop over Arabian Sea.',
      seasons: { depart: 'October', arrive: 'November', return: 'April' },
      tips: 'Nagaland, India sees millions during autumn migration.',
      route: [
        { lat: 50.0, lng: 120.0, name: 'Mongolia/China Breeding' },
        { lat: 35.0, lng: 105.0, name: 'Central China' },
        { lat: 26.0, lng: 94.0, name: 'Nagaland, India' },
        { lat: 15.0, lng: 75.0, name: 'Western India' },
        { lat: 5.0, lng: 55.0, name: 'Arabian Sea Crossing' },
        { lat: 0.0, lng: 42.0, name: 'Somalia' },
        { lat: -25.0, lng: 28.0, name: 'Southern Africa' },
      ],
      color: '#6366F1'
    },
    {
      id: 'red-knot',
      name: 'Red Knot',
      scientificName: 'Calidris canutus',
      category: 'birds',
      icon: '🐦',
      image: 'https://images.unsplash.com/photo-1647280100381-ab128a185db8?w=800&h=600&fit=crop',
      gallery: [
        'https://images.unsplash.com/photo-1571485460268-f3a3b3c7c4c2?w=800&h=600&fit=crop',
        'https://images.unsplash.com/photo-1568604209776-b8f23cf32b9a?w=800&h=600&fit=crop',
      ],
      status: 'Near Threatened',
      distance: '15,000 km one-way',
      description: 'Flies from Arctic to the tip of South America, dependent on horseshoe crab eggs.',
      seasons: { depart: 'August', arrive: 'October', return: 'May' },
      tips: 'Delaware Bay in May - critical refueling stop during spring migration.',
      route: [
        { lat: 76.0, lng: -100.0, name: 'Canadian Arctic Breeding' },
        { lat: 60.0, lng: -80.0, name: 'Hudson Bay' },
        { lat: 39.0, lng: -75.0, name: 'Delaware Bay' },
        { lat: 25.0, lng: -80.0, name: 'Florida Coast' },
        { lat: -5.0, lng: -50.0, name: 'Northern Brazil' },
        { lat: -40.0, lng: -62.0, name: 'Patagonia' },
        { lat: -53.0, lng: -70.0, name: 'Tierra del Fuego' },
      ],
      color: '#B45309'
    },
    {
      id: 'northern-wheatear',
      name: 'Northern Wheatear',
      scientificName: 'Oenanthe oenanthe',
      category: 'birds',
      icon: '🐦',
      image: 'https://images.unsplash.com/photo-1702916451199-df8f8057205e?w=800&h=600&fit=crop',
      gallery: [
        'https://images.unsplash.com/photo-1632082892866-d5d21c350bad?w=800&h=600&fit=crop',
        'https://images.unsplash.com/photo-1607462519946-b7d8bd4dc08f?w=800&h=600&fit=crop',
      ],
      status: 'Least Concern',
      distance: '14,500 km',
      description: 'Tiny songbird makes one of the longest migrations - Alaska to Africa!',
      seasons: { depart: 'August', arrive: 'October', return: 'May' },
      tips: 'Look for them in rocky, open terrain during breeding season.',
      route: [
        { lat: 65.0, lng: -165.0, name: 'Alaska Breeding' },
        { lat: 60.0, lng: -140.0, name: 'Yukon' },
        { lat: 55.0, lng: -60.0, name: 'Eastern Canada' },
        { lat: 45.0, lng: -30.0, name: 'North Atlantic' },
        { lat: 35.0, lng: -10.0, name: 'Morocco' },
        { lat: 15.0, lng: 0.0, name: 'Sahel Region' },
        { lat: 5.0, lng: 10.0, name: 'West Africa' },
      ],
      color: '#D97706'
    },
    {
      id: 'white-stork',
      name: 'White Stork',
      scientificName: 'Ciconia ciconia',
      category: 'birds',
      icon: '🦢',
      image: 'https://images.unsplash.com/photo-1704850509762-46de53b27444?w=800&h=600&fit=crop',
      gallery: [
        'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=800&h=600&fit=crop',
        'https://images.unsplash.com/photo-1590933079820-9e0bc39ca13f?w=800&h=600&fit=crop',
      ],
      status: 'Least Concern',
      distance: '20,000 km/year',
      description: 'Iconic European bird that avoids flying over Mediterranean, uses thermals.',
      seasons: { depart: 'August', arrive: 'October', return: 'March' },
      tips: 'Gibraltar and Bosphorus Strait - major migration bottlenecks.',
      route: [
        { lat: 52.0, lng: 10.0, name: 'Germany/Poland Breeding' },
        { lat: 45.0, lng: 15.0, name: 'Balkans' },
        { lat: 41.0, lng: 29.0, name: 'Bosphorus Strait' },
        { lat: 32.0, lng: 35.0, name: 'Israel/Jordan' },
        { lat: 25.0, lng: 33.0, name: 'Nile Valley' },
        { lat: 10.0, lng: 35.0, name: 'Sudan' },
        { lat: 0.0, lng: 32.0, name: 'East Africa' },
      ],
      color: '#F9FAFB'
    },
    {
      id: 'short-tailed-shearwater',
      name: 'Short-tailed Shearwater',
      scientificName: 'Ardenna tenuirostris',
      category: 'birds',
      icon: '🐦',
      image: 'https://images.unsplash.com/photo-1748216188337-0c9141248bab?w=800&h=600&fit=crop',
      gallery: [
        'https://images.unsplash.com/photo-1599490659213-e2b9527bd087?w=800&h=600&fit=crop',
        'https://images.unsplash.com/photo-1622017911841-6acf0a2af35b?w=800&h=600&fit=crop',
      ],
      status: 'Least Concern',
      distance: '32,000 km/year',
      description: 'Australian "mutton bird" makes epic Pacific crossing to Arctic each year.',
      seasons: { depart: 'April', arrive: 'May', return: 'September' },
      tips: 'Phillip Island, Australia - millions return at dusk during breeding.',
      route: [
        { lat: -38.5, lng: 145.0, name: 'Tasmania/Victoria Breeding' },
        { lat: -30.0, lng: 160.0, name: 'Tasman Sea' },
        { lat: 0.0, lng: 170.0, name: 'Equatorial Pacific' },
        { lat: 35.0, lng: 175.0, name: 'North Pacific' },
        { lat: 55.0, lng: 195.0, name: 'Bering Sea' },
        { lat: 40.0, lng: 210.0, name: 'Return via East Pacific' },
      ],
      color: '#374151'
    },
    {
      id: 'wandering-albatross',
      name: 'Wandering Albatross',
      scientificName: 'Diomedea exulans',
      category: 'birds',
      icon: '🕊️',
      image: 'https://images.unsplash.com/photo-1631629900556-3664adf220b8?w=800&h=600&fit=crop',
      gallery: [
        'https://images.unsplash.com/photo-1504173010664-32509107de39?w=800&h=600&fit=crop',
        'https://images.unsplash.com/photo-1568605114967-8130f3a36994?w=800&h=600&fit=crop',
      ],
      status: 'Vulnerable',
      distance: '120,000 km/year',
      description: 'Longest wingspan of any living bird, circumnavigates the Southern Ocean on wind currents.',
      seasons: { depart: 'Variable', arrive: 'Variable', return: 'Variable' },
      tips: 'South Georgia Island and New Zealand subantarctic islands for breeding colonies.',
      route: [
        { lat: -54.0, lng: -36.0, name: 'South Georgia Island' },
        { lat: -50.0, lng: 0.0, name: 'South Atlantic' },
        { lat: -48.0, lng: 40.0, name: 'Indian Ocean' },
        { lat: -46.0, lng: 80.0, name: 'Southern Indian Ocean' },
        { lat: -50.0, lng: 140.0, name: 'South of Australia' },
        { lat: -52.0, lng: 190.0, name: 'South Pacific' },
        { lat: -55.0, lng: 290.0, name: 'Drake Passage' },
      ],
      color: '#94A3B8'
    },
    {
      id: 'blackpoll-warbler',
      name: 'Blackpoll Warbler',
      scientificName: 'Setophaga striata',
      category: 'birds',
      icon: '🐦',
      image: 'https://images.unsplash.com/photo-1696104139747-eff0408f30bb?w=800&h=600&fit=crop',
      gallery: [
        'https://images.unsplash.com/photo-1548526928-b34b5e2b1a36?w=800&h=600&fit=crop',
        'https://images.unsplash.com/photo-1606567595334-d39972c85e11?w=800&h=600&fit=crop',
      ],
      status: 'Near Threatened',
      distance: '2,700 km non-stop',
      description: 'A 12-gram songbird that flies non-stop over the Atlantic Ocean for 3 days.',
      seasons: { depart: 'October', arrive: 'November', return: 'May' },
      tips: 'Cape Cod and Atlantic coast in fall for staging flocks before ocean crossing.',
      route: [
        { lat: 63.0, lng: -140.0, name: 'Alaska/Yukon Breeding' },
        { lat: 55.0, lng: -80.0, name: 'Boreal Canada' },
        { lat: 42.0, lng: -70.0, name: 'New England Staging' },
        { lat: 25.0, lng: -60.0, name: 'Over Atlantic Ocean' },
        { lat: 10.0, lng: -62.0, name: 'Venezuela/Caribbean' },
      ],
      color: '#334155'
    },
    {
      id: 'sandhill-crane',
      name: 'Sandhill Crane',
      scientificName: 'Antigone canadensis',
      category: 'birds',
      icon: '🦢',
      image: 'https://images.unsplash.com/photo-1698713196053-903b459d3771?w=800&h=600&fit=crop',
      gallery: [
        'https://images.unsplash.com/photo-1588421357574-87938a86fa28?w=800&h=600&fit=crop',
        'https://images.unsplash.com/photo-1553526665-dbfe3e8e7e53?w=800&h=600&fit=crop',
      ],
      status: 'Least Concern',
      distance: '5,000 km',
      description: 'Over 500,000 cranes gather on Nebraska\'s Platte River each spring — one of nature\'s great spectacles.',
      seasons: { depart: 'September', arrive: 'November', return: 'March' },
      tips: 'Platte River, Nebraska in March for the largest crane gathering on Earth.',
      route: [
        { lat: 64.0, lng: -155.0, name: 'Alaska Breeding Grounds' },
        { lat: 55.0, lng: -120.0, name: 'Northern Alberta' },
        { lat: 41.0, lng: -100.0, name: 'Platte River, Nebraska' },
        { lat: 35.0, lng: -106.0, name: 'Bosque del Apache, NM' },
        { lat: 28.0, lng: -97.0, name: 'Texas Gulf Coast' },
      ],
      color: '#7E8C9A'
    },
  ],
  mammals: [
    {
      id: 'wildebeest',
      name: 'Wildebeest',
      scientificName: 'Connochaetes taurinus',
      category: 'mammals',
      icon: '🦬',
      image: 'https://images.unsplash.com/photo-1709842460895-cf865af93baf?w=800&h=600&fit=crop',
      gallery: [
        'https://images.unsplash.com/photo-1547471080-7cc2caa01a7e?w=800&h=600&fit=crop',
        'https://images.unsplash.com/photo-1516426122078-c23e76319801?w=800&h=600&fit=crop',
      ],
      status: 'Least Concern',
      distance: '800 km circular',
      description: 'The Great Migration: 1.5 million animals move as one.',
      seasons: { depart: 'July', arrive: 'October', return: 'January' },
      tips: 'Visit Masai Mara July-October for the famous river crossings.',
      route: [
        { lat: -2.5, lng: 34.8, name: 'Southern Serengeti' },
        { lat: -2.0, lng: 34.5, name: 'Central Serengeti' },
        { lat: -1.5, lng: 35.0, name: 'Western Corridor' },
        { lat: -1.3, lng: 35.2, name: 'Grumeti River' },
        { lat: -1.4, lng: 35.1, name: 'Masai Mara' },
      ],
      color: '#A16207'
    },
    {
      id: 'caribou',
      name: 'Caribou',
      scientificName: 'Rangifer tarandus',
      category: 'mammals',
      icon: '🦌',
      image: 'https://images.unsplash.com/photo-1543955525-226e567ca7bb?w=800&h=600&fit=crop',
      gallery: [
        'https://images.unsplash.com/photo-1589500530947-3fd2f7c4ad71?w=800&h=600&fit=crop',
        'https://images.unsplash.com/photo-1558981403-c5f9899a28bc?w=800&h=600&fit=crop',
      ],
      status: 'Vulnerable',
      distance: '5,000 km/year',
      description: 'North America\'s great terrestrial migration.',
      seasons: { depart: 'April', arrive: 'June', return: 'October' },
      tips: 'Arctic National Wildlife Refuge offers prime viewing.',
      route: [
        { lat: 66.0, lng: -145.0, name: 'Winter Range (Yukon)' },
        { lat: 68.0, lng: -143.0, name: 'Brooks Range' },
        { lat: 69.5, lng: -144.0, name: 'Coastal Plain' },
        { lat: 70.0, lng: -145.0, name: 'Calving Grounds' },
      ],
      color: '#7C3AED'
    },
    {
      id: 'elephant',
      name: 'African Elephant',
      scientificName: 'Loxodonta africana',
      category: 'mammals',
      icon: '🐘',
      image: 'https://images.unsplash.com/photo-1611262084470-0e8686d7be78?w=800&h=600&fit=crop',
      gallery: [
        'https://images.unsplash.com/photo-1474511320723-9a56873867b5?w=800&h=600&fit=crop',
        'https://images.unsplash.com/photo-1557050543-4d5f4e07ef46?w=800&h=600&fit=crop',
      ],
      status: 'Endangered',
      distance: '500 km seasonal',
      description: 'Follow ancient paths between water sources and feeding grounds.',
      seasons: { depart: 'May', arrive: 'July', return: 'November' },
      tips: 'Chobe National Park in Botswana has massive herds.',
      route: [
        { lat: -19.0, lng: 25.5, name: 'Chobe River' },
        { lat: -18.5, lng: 24.5, name: 'Savuti Marsh' },
        { lat: -19.5, lng: 23.5, name: 'Okavango Delta' },
        { lat: -20.0, lng: 22.5, name: 'Makgadikgadi Pans' },
      ],
      color: '#6B7280'
    },
    {
      id: 'zebra',
      name: 'Plains Zebra',
      scientificName: 'Equus quagga',
      category: 'mammals',
      icon: '🦓',
      image: 'https://images.unsplash.com/photo-1526095179574-86e545346ae6?w=800&h=600&fit=crop',
      gallery: [
        'https://images.unsplash.com/photo-1518020382113-a7e8fc38eac9?w=800&h=600&fit=crop',
        'https://images.unsplash.com/photo-1501706362039-c06b2d715385?w=800&h=600&fit=crop',
      ],
      status: 'Near Threatened',
      distance: '500 km',
      description: 'Botswana\'s zebra migration is Africa\'s longest.',
      seasons: { depart: 'November', arrive: 'January', return: 'April' },
      tips: 'Makgadikgadi Pans during rainy season is spectacular.',
      route: [
        { lat: -18.5, lng: 24.0, name: 'Okavango Delta' },
        { lat: -19.5, lng: 24.5, name: 'Nxai Pan' },
        { lat: -20.5, lng: 25.2, name: 'Makgadikgadi' },
      ],
      color: '#1F2937'
    },
    {
      id: 'blue-whale',
      name: 'Blue Whale',
      scientificName: 'Balaenoptera musculus',
      category: 'mammals',
      icon: '🐋',
      image: 'https://images.unsplash.com/photo-1698334846759-2cdc3352dd85?w=800&h=600&fit=crop',
      gallery: [
        'https://images.unsplash.com/photo-1568430462989-44163eb1752f?w=800&h=600&fit=crop',
        'https://images.unsplash.com/photo-1612443385720-b4181d2ab928?w=800&h=600&fit=crop',
      ],
      status: 'Endangered',
      distance: '10,000 km',
      description: 'The largest animal to ever exist, migrating between polar and tropical waters.',
      seasons: { depart: 'Autumn', arrive: 'Winter', return: 'Spring' },
      tips: 'Sri Lanka and Azores offer best blue whale watching opportunities.',
      route: [
        { lat: -60.0, lng: -60.0, name: 'Antarctic Feeding Grounds' },
        { lat: -40.0, lng: -70.0, name: 'South Pacific' },
        { lat: -20.0, lng: -85.0, name: 'Chilean Coast' },
        { lat: 0.0, lng: -90.0, name: 'Galápagos Waters' },
        { lat: 20.0, lng: -110.0, name: 'Gulf of California' },
      ],
      color: '#1E3A8A'
    },
    {
      id: 'pronghorn',
      name: 'Pronghorn Antelope',
      scientificName: 'Antilocapra americana',
      category: 'mammals',
      icon: '🦌',
      image: 'https://images.unsplash.com/photo-1598113927122-3a94e93030d3?w=800&h=600&fit=crop',
      gallery: [
        'https://images.unsplash.com/photo-1628524460685-7eb1bdf34b01?w=800&h=600&fit=crop',
        'https://images.unsplash.com/photo-1598133893773-de3574464ef0?w=800&h=600&fit=crop',
      ],
      status: 'Least Concern',
      distance: '500 km',
      description: 'Fastest land animal in the Americas, ancient migration routes now threatened.',
      seasons: { depart: 'October', arrive: 'December', return: 'April' },
      tips: 'Grand Teton National Park has the longest pronghorn migration corridor.',
      route: [
        { lat: 43.8, lng: -110.5, name: 'Grand Teton Summer Range' },
        { lat: 43.2, lng: -110.0, name: 'Gros Ventre Mountains' },
        { lat: 42.5, lng: -109.5, name: 'Migration Corridor' },
        { lat: 42.0, lng: -109.0, name: 'Green River Winter Range' },
      ],
      color: '#D97706'
    },
    {
      id: 'straw-colored-fruit-bat',
      name: 'Straw-colored Fruit Bat',
      scientificName: 'Eidolon helvum',
      category: 'mammals',
      icon: '🦇',
      image: 'https://images.unsplash.com/photo-1668188235549-73adeb2545c0?w=800&h=600&fit=crop',
      gallery: [
        'https://images.unsplash.com/photo-1650637229546-2542cdfb2b15?w=800&h=600&fit=crop',
        'https://images.unsplash.com/photo-1570983028428-9e99cddfca4e?w=800&h=600&fit=crop',
      ],
      status: 'Near Threatened',
      distance: '2,000 km',
      description: 'World\'s largest mammal migration by numbers - over 10 million bats!',
      seasons: { depart: 'October', arrive: 'November', return: 'December' },
      tips: 'Kasanka National Park, Zambia hosts the spectacular gathering.',
      route: [
        { lat: 0.0, lng: 20.0, name: 'Congo Basin' },
        { lat: -5.0, lng: 25.0, name: 'DRC Forests' },
        { lat: -10.0, lng: 28.0, name: 'Northern Zambia' },
        { lat: -12.3, lng: 30.2, name: 'Kasanka National Park' },
      ],
      color: '#78350F'
    },
    {
      id: 'mexican-free-tailed-bat',
      name: 'Mexican Free-tailed Bat',
      scientificName: 'Tadarida brasiliensis',
      category: 'mammals',
      icon: '🦇',
      image: 'https://images.unsplash.com/photo-1593179532767-a3b04e5e2cff?w=800&h=600&fit=crop',
      gallery: [
        'https://images.unsplash.com/photo-1668188235549-73adeb2545c0?w=800&h=600&fit=crop',
        'https://images.unsplash.com/photo-1570983028428-9e99cddfca4e?w=800&h=600&fit=crop',
      ],
      status: 'Least Concern',
      distance: '1,800 km',
      description: 'Forms colonies of 20+ million in Texas caves - largest bat colonies on Earth.',
      seasons: { depart: 'March', arrive: 'April', return: 'October' },
      tips: 'Bracken Cave near San Antonio for the world\'s largest bat colony.',
      route: [
        { lat: 20.0, lng: -100.0, name: 'Central Mexico' },
        { lat: 25.0, lng: -100.0, name: 'Northern Mexico' },
        { lat: 29.5, lng: -98.5, name: 'Bracken Cave, Texas' },
        { lat: 30.5, lng: -98.0, name: 'Texas Hill Country' },
      ],
      color: '#451A03'
    },
    {
      id: 'saiga-antelope',
      name: 'Saiga Antelope',
      scientificName: 'Saiga tatarica',
      category: 'mammals',
      icon: '🦌',
      image: 'https://images.unsplash.com/photo-1599907339757-bcd005a3fb0d?w=800&h=600&fit=crop',
      gallery: [
        'https://images.unsplash.com/photo-1544985361-b420d7a77043?w=800&h=600&fit=crop',
        'https://images.unsplash.com/photo-1609562042576-bc3294a25daf?w=800&h=600&fit=crop',
      ],
      status: 'Critically Endangered',
      distance: '1,000 km',
      description: 'Distinctive bulbous nose filters dust in summer and warms air in winter.',
      seasons: { depart: 'November', arrive: 'December', return: 'April' },
      tips: 'Betpak-Dala region of Kazakhstan for remaining wild populations.',
      route: [
        { lat: 47.0, lng: 66.0, name: 'Northern Kazakhstan Summer' },
        { lat: 45.0, lng: 63.0, name: 'Betpak-Dala' },
        { lat: 43.0, lng: 60.0, name: 'Ustyurt Plateau' },
        { lat: 41.0, lng: 58.0, name: 'Southern Winter Range' },
      ],
      color: '#D4A574'
    },
    {
      id: 'mule-deer',
      name: 'Mule Deer',
      scientificName: 'Odocoileus hemionus',
      category: 'mammals',
      icon: '🦌',
      image: 'https://images.unsplash.com/photo-1609562042576-bc3294a25daf?w=800&h=600&fit=crop',
      gallery: [
        'https://images.unsplash.com/photo-1599907339757-bcd005a3fb0d?w=800&h=600&fit=crop',
        'https://images.unsplash.com/photo-1589500530947-3fd2f7c4ad71?w=800&h=600&fit=crop',
      ],
      status: 'Least Concern',
      distance: '240 km',
      description: 'Red Desert to Hoback migration - longest mule deer migration ever recorded.',
      seasons: { depart: 'November', arrive: 'December', return: 'April' },
      tips: 'Wyoming\'s Sublette County for viewing the historic corridor.',
      route: [
        { lat: 43.0, lng: -109.5, name: 'Hoback Basin Winter' },
        { lat: 42.5, lng: -109.7, name: 'Wyoming Range' },
        { lat: 42.0, lng: -109.3, name: 'Green River Basin' },
        { lat: 41.5, lng: -108.5, name: 'Red Desert Summer' },
      ],
      color: '#92400E'
    },
    {
      id: 'beluga-whale',
      name: 'Beluga Whale',
      scientificName: 'Delphinapterus leucas',
      category: 'mammals',
      icon: '🐋',
      image: 'https://images.unsplash.com/photo-1612443385720-b4181d2ab928?w=800&h=600&fit=crop',
      gallery: [
        'https://images.unsplash.com/photo-1559827291-72ee739d0d9a?w=800&h=600&fit=crop',
        'https://images.unsplash.com/photo-1698472505070-6d3b90afb530?w=800&h=600&fit=crop',
      ],
      status: 'Least Concern',
      distance: '2,500 km',
      description: 'The "canary of the sea" - highly vocal white whale of Arctic waters.',
      seasons: { depart: 'September', arrive: 'November', return: 'June' },
      tips: 'Churchill, Manitoba in summer for kayaking with belugas.',
      route: [
        { lat: 74.0, lng: -95.0, name: 'High Arctic Summer' },
        { lat: 70.0, lng: -90.0, name: 'Baffin Bay' },
        { lat: 63.0, lng: -85.0, name: 'Hudson Strait' },
        { lat: 58.8, lng: -94.2, name: 'Churchill River Estuary' },
      ],
      color: '#F5F5F5'
    },
    {
      id: 'sperm-whale',
      name: 'Sperm Whale',
      scientificName: 'Physeter macrocephalus',
      category: 'mammals',
      icon: '🐋',
      image: 'https://images.unsplash.com/photo-1698472505070-6d3b90afb530?w=800&h=600&fit=crop',
      gallery: [
        'https://images.unsplash.com/photo-1612443385720-b4181d2ab928?w=800&h=600&fit=crop',
        'https://images.unsplash.com/photo-1559827291-72ee739d0d9a?w=800&h=600&fit=crop',
      ],
      status: 'Vulnerable',
      distance: '10,000 km',
      description: 'Deepest diving mammal, can reach 2,250m hunting giant squid.',
      seasons: { depart: 'Variable', arrive: 'Variable', return: 'Variable' },
      tips: 'Kaikoura, New Zealand and Azores for reliable year-round sightings.',
      route: [
        { lat: 38.5, lng: -28.0, name: 'Azores' },
        { lat: 30.0, lng: -35.0, name: 'North Atlantic' },
        { lat: 15.0, lng: -45.0, name: 'Caribbean' },
        { lat: 0.0, lng: -35.0, name: 'Equatorial Atlantic' },
        { lat: -20.0, lng: -30.0, name: 'South Atlantic' },
      ],
      color: '#1F2937'
    },
    {
      id: 'narwhal',
      name: 'Narwhal',
      scientificName: 'Monodon monoceros',
      category: 'mammals',
      icon: '🐋',
      image: 'https://images.unsplash.com/photo-1754416189419-fb673d49ecb0?w=800&h=600&fit=crop',
      gallery: [
        'https://images.unsplash.com/photo-1559827291-72ee739d0d9a?w=800&h=600&fit=crop',
        'https://images.unsplash.com/photo-1504573574048-bca0ca39bd64?w=800&h=600&fit=crop',
      ],
      status: 'Least Concern',
      distance: '2,000 km',
      description: 'The "unicorn of the sea" — Arctic endemic whose tusk is actually a sensory tooth.',
      seasons: { depart: 'June', arrive: 'August', return: 'October' },
      tips: 'Arctic Bay, Nunavut in summer for rare narwhal sightings at the floe edge.',
      route: [
        { lat: 76.0, lng: -80.0, name: 'High Arctic Winter (Baffin Bay)' },
        { lat: 73.0, lng: -70.0, name: 'Eclipse Sound' },
        { lat: 71.0, lng: -85.0, name: 'Lancaster Sound' },
        { lat: 74.0, lng: -60.0, name: 'Greenland Coast' },
        { lat: 78.0, lng: -72.0, name: 'Deep Baffin Bay' },
      ],
      color: '#7DD3FC'
    },
    {
      id: 'dugong',
      name: 'Dugong',
      scientificName: 'Dugong dugon',
      category: 'mammals',
      icon: '🐋',
      image: 'https://images.unsplash.com/photo-1660849266159-e7b2c3dd352e?w=800&h=600&fit=crop',
      gallery: [
        'https://images.unsplash.com/photo-1559827260-dc66d52bef19?w=800&h=600&fit=crop',
        'https://images.unsplash.com/photo-1516426122078-c23e76319801?w=800&h=600&fit=crop',
      ],
      status: 'Vulnerable',
      distance: '600 km',
      description: 'The only strictly marine herbivorous mammal, grazing on seagrass meadows across the Indo-Pacific.',
      seasons: { depart: 'Variable', arrive: 'Variable', return: 'Variable' },
      tips: 'Shark Bay, Western Australia and Marsa Alam, Egypt for reliable sightings.',
      route: [
        { lat: -25.5, lng: 113.5, name: 'Shark Bay, Australia' },
        { lat: -20.0, lng: 118.0, name: 'Pilbara Coast' },
        { lat: -15.0, lng: 125.0, name: 'Kimberley Coast' },
        { lat: -12.0, lng: 135.0, name: 'Arnhem Land' },
        { lat: -10.0, lng: 142.0, name: 'Torres Strait' },
      ],
      color: '#A1887F'
    },
  ],
  marine: [
    {
      id: 'humpback-whale',
      name: 'Humpback Whale',
      scientificName: 'Megaptera novaeangliae',
      category: 'marine',
      icon: '🐋',
      image: 'https://images.unsplash.com/photo-1568430462989-44163eb1752f?w=800&h=600&fit=crop',
      gallery: [
        'https://images.unsplash.com/photo-1563779367083-1e2060175532?w=800&h=600&fit=crop',
        'https://images.unsplash.com/photo-1698334846759-2cdc3352dd85?w=800&h=600&fit=crop',
      ],
      status: 'Least Concern',
      distance: '8,000 km',
      description: 'Longest migration of any mammal, singing as they go.',
      seasons: { depart: 'June', arrive: 'August', return: 'November' },
      tips: 'Hawaii in winter, Alaska in summer for whale watching.',
      route: [
        { lat: 58.0, lng: -135.0, name: 'Alaska Feeding Grounds' },
        { lat: 45.0, lng: -135.0, name: 'North Pacific' },
        { lat: 30.0, lng: -140.0, name: 'Central Pacific' },
        { lat: 20.0, lng: -156.0, name: 'Hawaii Breeding Grounds' },
      ],
      color: '#0EA5E9'
    },
    {
      id: 'gray-whale',
      name: 'Gray Whale',
      scientificName: 'Eschrichtius robustus',
      category: 'marine',
      icon: '🐳',
      image: 'https://images.unsplash.com/photo-1563779367083-1e2060175532?w=800&h=600&fit=crop',
      gallery: [
        'https://images.unsplash.com/photo-1568430462989-44163eb1752f?w=800&h=600&fit=crop',
        'https://images.unsplash.com/photo-1612443385720-b4181d2ab928?w=800&h=600&fit=crop',
      ],
      status: 'Least Concern',
      distance: '20,000 km round trip',
      description: 'One of the longest migrations of any mammal.',
      seasons: { depart: 'October', arrive: 'January', return: 'April' },
      tips: 'Watch from California coast December-April.',
      route: [
        { lat: 65.0, lng: -170.0, name: 'Bering Sea' },
        { lat: 55.0, lng: -160.0, name: 'Gulf of Alaska' },
        { lat: 45.0, lng: -130.0, name: 'Pacific Northwest' },
        { lat: 35.0, lng: -122.0, name: 'California Coast' },
        { lat: 27.0, lng: -114.0, name: 'Baja California' },
      ],
      color: '#64748B'
    },
    {
      id: 'leatherback-turtle',
      name: 'Leatherback Sea Turtle',
      scientificName: 'Dermochelys coriacea',
      category: 'marine',
      icon: '🐢',
      image: 'https://images.unsplash.com/photo-1633883494580-5cd8d8c45207?w=800&h=600&fit=crop',
      gallery: [
        'https://images.unsplash.com/photo-1574248265178-622da6d65714?w=800&h=600&fit=crop',
        'https://images.unsplash.com/photo-1633940836680-53d33a74e0db?w=800&h=600&fit=crop',
      ],
      status: 'Vulnerable',
      distance: '16,000 km',
      description: 'Deepest diving and most migratory of all sea turtles.',
      seasons: { depart: 'Year-round', arrive: 'Varies', return: 'Varies' },
      tips: 'Trinidad beaches for nesting; open ocean otherwise.',
      route: [
        { lat: 10.0, lng: -61.0, name: 'Trinidad (Nesting)' },
        { lat: 20.0, lng: -65.0, name: 'Caribbean Sea' },
        { lat: 35.0, lng: -55.0, name: 'North Atlantic' },
        { lat: 50.0, lng: -35.0, name: 'Feeding Grounds' },
      ],
      color: '#059669'
    },
    {
      id: 'great-white-shark',
      name: 'Great White Shark',
      scientificName: 'Carcharodon carcharias',
      category: 'marine',
      icon: '🦈',
      image: 'https://images.unsplash.com/photo-1637380781238-9b703b0d2db0?w=800&h=600&fit=crop',
      gallery: [
        'https://images.unsplash.com/photo-1709494550287-b4cb3c25518e?w=800&h=600&fit=crop',
        'https://images.unsplash.com/photo-1544552866-49ce864ff896?w=800&h=600&fit=crop',
      ],
      status: 'Vulnerable',
      distance: '20,000 km',
      description: 'Travels vast oceanic distances between feeding areas.',
      seasons: { depart: 'Winter', arrive: 'Spring', return: 'Fall' },
      tips: 'Cage diving in South Africa or Guadalupe Island.',
      route: [
        { lat: -34.0, lng: 18.5, name: 'South Africa' },
        { lat: -40.0, lng: 60.0, name: 'Indian Ocean' },
        { lat: -35.0, lng: 115.0, name: 'Western Australia' },
      ],
      color: '#374151'
    },
    {
      id: 'bluefin-tuna',
      name: 'Atlantic Bluefin Tuna',
      scientificName: 'Thunnus thynnus',
      category: 'marine',
      icon: '🐟',
      image: 'https://images.unsplash.com/photo-1562053923-52d3ebb09d31?w=800&h=600&fit=crop',
      gallery: [
        'https://images.unsplash.com/photo-1516026672322-bc52d61a55d5?w=800&h=600&fit=crop',
        'https://images.unsplash.com/photo-1534695440827-cff7de99b2c2?w=800&h=600&fit=crop',
      ],
      status: 'Endangered',
      distance: '16,000 km',
      description: 'One of the fastest fish, crossing the Atlantic multiple times per year.',
      seasons: { depart: 'April', arrive: 'June', return: 'October' },
      tips: 'Mediterranean Sea for spawning; North Atlantic for feeding.',
      route: [
        { lat: 42.0, lng: -70.0, name: 'Gulf of Maine' },
        { lat: 45.0, lng: -40.0, name: 'Mid-Atlantic' },
        { lat: 40.0, lng: -10.0, name: 'Eastern Atlantic' },
        { lat: 38.0, lng: 5.0, name: 'Mediterranean Spawning' },
      ],
      color: '#1E40AF'
    },
    {
      id: 'chinook-salmon',
      name: 'Chinook Salmon',
      scientificName: 'Oncorhynchus tshawytscha',
      category: 'marine',
      icon: '🐠',
      image: 'https://images.unsplash.com/photo-1498579150354-977475b7ea0b?w=800&h=600&fit=crop',
      gallery: [
        'https://images.unsplash.com/photo-1567705781486-b5671cb2f27d?w=800&h=600&fit=crop',
        'https://images.unsplash.com/photo-1653978787896-0cf89060a3bf?w=800&h=600&fit=crop',
      ],
      status: 'Vulnerable',
      distance: '1,500 km',
      description: 'The largest Pacific salmon, returning to birth rivers to spawn.',
      seasons: { depart: 'Spring', arrive: 'Summer', return: 'One-way' },
      tips: 'Watch spawning runs in Pacific Northwest rivers August-October.',
      route: [
        { lat: 50.0, lng: -145.0, name: 'Gulf of Alaska' },
        { lat: 48.0, lng: -125.0, name: 'Pacific Coast' },
        { lat: 46.5, lng: -124.0, name: 'Columbia River Mouth' },
        { lat: 46.0, lng: -118.0, name: 'Snake River' },
        { lat: 44.5, lng: -114.5, name: 'Idaho Spawning Grounds' },
      ],
      color: '#BE185D'
    },
    {
      id: 'european-eel',
      name: 'European Eel',
      scientificName: 'Anguilla anguilla',
      category: 'marine',
      icon: '🐍',
      image: 'https://images.unsplash.com/photo-1772909496985-65a7ab96c194?w=800&h=600&fit=crop',
      gallery: [
        'https://images.unsplash.com/photo-1534695440827-cff7de99b2c2?w=800&h=600&fit=crop',
        'https://images.unsplash.com/photo-1516026672322-bc52d61a55d5?w=800&h=600&fit=crop',
      ],
      status: 'Critically Endangered',
      distance: '5,000 km',
      description: 'Mysterious migration to the Sargasso Sea to spawn and die.',
      seasons: { depart: 'Autumn', arrive: 'Winter', return: 'One-way' },
      tips: 'European rivers in autumn for silver eel migration.',
      route: [
        { lat: 52.0, lng: 5.0, name: 'European Rivers' },
        { lat: 48.0, lng: -10.0, name: 'Bay of Biscay' },
        { lat: 40.0, lng: -30.0, name: 'Mid-Atlantic' },
        { lat: 28.0, lng: -65.0, name: 'Sargasso Sea Spawning' },
      ],
      color: '#4A5568'
    },
    {
      id: 'sockeye-salmon',
      name: 'Sockeye Salmon',
      scientificName: 'Oncorhynchus nerka',
      category: 'marine',
      icon: '🐟',
      image: 'https://images.unsplash.com/photo-1567705781486-b5671cb2f27d?w=800&h=600&fit=crop',
      gallery: [
        'https://images.unsplash.com/photo-1704303866732-93723c5325a4?w=800&h=600&fit=crop',
        'https://images.unsplash.com/photo-1653978787896-0cf89060a3bf?w=800&h=600&fit=crop',
      ],
      status: 'Least Concern',
      distance: '1,600 km',
      description: 'Turn brilliant crimson red during their dramatic spawning migration.',
      seasons: { depart: 'June', arrive: 'August', return: 'One-way' },
      tips: 'Adams River in British Columbia for one of the largest runs.',
      route: [
        { lat: 55.0, lng: -160.0, name: 'Gulf of Alaska' },
        { lat: 52.0, lng: -130.0, name: 'British Columbia Coast' },
        { lat: 50.5, lng: -125.0, name: 'Johnstone Strait' },
        { lat: 51.0, lng: -119.5, name: 'Adams River Spawning' },
      ],
      color: '#DC2626'
    },
    {
      id: 'northern-elephant-seal',
      name: 'Northern Elephant Seal',
      scientificName: 'Mirounga angustirostris',
      category: 'marine',
      icon: '🦭',
      image: 'https://images.unsplash.com/photo-1680371320408-25fbc4abd181?w=800&h=600&fit=crop',
      gallery: [
        'https://images.unsplash.com/photo-1568605114967-8130f3a36994?w=800&h=600&fit=crop',
        'https://images.unsplash.com/photo-1566428484192-180db41644db?w=800&h=600&fit=crop',
      ],
      status: 'Least Concern',
      distance: '21,000 km',
      description: 'Makes two epic migrations per year - longest of any pinniped.',
      seasons: { depart: 'February', arrive: 'August', return: 'December' },
      tips: 'Año Nuevo State Park, California for breeding colonies.',
      route: [
        { lat: 37.0, lng: -122.0, name: 'California Breeding' },
        { lat: 45.0, lng: -135.0, name: 'North Pacific' },
        { lat: 55.0, lng: -145.0, name: 'Gulf of Alaska Feeding' },
        { lat: 50.0, lng: -170.0, name: 'Aleutian Islands' },
      ],
      color: '#6B7280'
    },
    {
      id: 'whale-shark',
      name: 'Whale Shark',
      scientificName: 'Rhincodon typus',
      category: 'marine',
      icon: '🦈',
      image: 'https://images.unsplash.com/photo-1544552866-49ce864ff896?w=800&h=600&fit=crop',
      gallery: [
        'https://images.unsplash.com/photo-1637380781238-9b703b0d2db0?w=800&h=600&fit=crop',
        'https://images.unsplash.com/photo-1618265909156-0507770ef0d0?w=800&h=600&fit=crop',
      ],
      status: 'Endangered',
      distance: '13,000 km',
      description: 'Largest fish on Earth, follows plankton blooms across tropical oceans.',
      seasons: { depart: 'Variable', arrive: 'Variable', return: 'Variable' },
      tips: 'Ningaloo Reef (Australia) and Isla Holbox (Mexico) for swimming encounters.',
      route: [
        { lat: 21.5, lng: -87.0, name: 'Yucatan Peninsula' },
        { lat: 15.0, lng: -95.0, name: 'Gulf of Tehuantepec' },
        { lat: 5.0, lng: -90.0, name: 'Eastern Pacific' },
        { lat: -5.0, lng: -82.0, name: 'Galapagos Islands' },
        { lat: 10.0, lng: -105.0, name: 'Cocos Island' },
      ],
      color: '#1E40AF'
    },
    {
      id: 'manta-ray',
      name: 'Giant Manta Ray',
      scientificName: 'Mobula birostris',
      category: 'marine',
      icon: '🐟',
      image: 'https://images.unsplash.com/photo-1618265909156-0507770ef0d0?w=800&h=600&fit=crop',
      gallery: [
        'https://images.unsplash.com/photo-1544552866-49ce864ff896?w=800&h=600&fit=crop',
        'https://images.unsplash.com/photo-1559827260-dc66d52bef19?w=800&h=600&fit=crop',
      ],
      status: 'Endangered',
      distance: '1,100 km',
      description: 'Largest ray species, identified individually by unique belly markings.',
      seasons: { depart: 'Variable', arrive: 'Variable', return: 'Variable' },
      tips: 'Kona, Hawaii and Maldives offer night dives with feeding mantas.',
      route: [
        { lat: -8.0, lng: 115.5, name: 'Bali, Indonesia' },
        { lat: -10.0, lng: 120.0, name: 'Komodo National Park' },
        { lat: -5.0, lng: 130.0, name: 'Raja Ampat' },
        { lat: 0.0, lng: 125.0, name: 'North Sulawesi' },
      ],
      color: '#1E3A8A'
    },
    {
      id: 'swordfish',
      name: 'Swordfish',
      scientificName: 'Xiphias gladius',
      category: 'marine',
      icon: '🐟',
      image: 'https://images.unsplash.com/photo-1637308101513-10f6e78d5514?w=800&h=600&fit=crop',
      gallery: [
        'https://images.unsplash.com/photo-1562053923-52d3ebb09d31?w=800&h=600&fit=crop',
        'https://images.unsplash.com/photo-1516026672322-bc52d61a55d5?w=800&h=600&fit=crop',
      ],
      status: 'Least Concern',
      distance: '5,000 km',
      description: 'Fast predator that migrates vertically daily and horizontally seasonally.',
      seasons: { depart: 'Spring', arrive: 'Summer', return: 'Fall' },
      tips: 'Deep-sea fishing off New England and Mediterranean during summer.',
      route: [
        { lat: 25.0, lng: -75.0, name: 'Caribbean Spawning' },
        { lat: 32.0, lng: -65.0, name: 'Sargasso Sea' },
        { lat: 40.0, lng: -70.0, name: 'Georges Bank' },
        { lat: 42.0, lng: -65.0, name: 'Gulf of Maine' },
        { lat: 38.0, lng: -73.0, name: 'Mid-Atlantic' },
      ],
      color: '#3730A3'
    },
    {
      id: 'ocean-sunfish',
      name: 'Ocean Sunfish',
      scientificName: 'Mola mola',
      category: 'marine',
      icon: '🐟',
      image: 'https://images.unsplash.com/photo-1753718751410-0457668e9822?w=800&h=600&fit=crop',
      gallery: [
        'https://images.unsplash.com/photo-1560713781-d1f64e0d0a5f?w=800&h=600&fit=crop',
        'https://images.unsplash.com/photo-1534695440827-cff7de99b2c2?w=800&h=600&fit=crop',
      ],
      status: 'Vulnerable',
      distance: '26 km/day',
      description: 'Heaviest bony fish, makes deep vertical migrations following jellyfish prey.',
      seasons: { depart: 'Variable', arrive: 'Variable', return: 'Variable' },
      tips: 'Bali and Galapagos for diving encounters; surface on calm days.',
      route: [
        { lat: 36.0, lng: -122.0, name: 'Monterey Bay' },
        { lat: 33.0, lng: -120.0, name: 'Channel Islands' },
        { lat: 28.0, lng: -115.0, name: 'Baja California' },
        { lat: 20.0, lng: -110.0, name: 'Sea of Cortez' },
      ],
      color: '#4338CA'
    },
    {
      id: 'atlantic-salmon',
      name: 'Atlantic Salmon',
      scientificName: 'Salmo salar',
      category: 'marine',
      icon: '🐟',
      image: 'https://images.unsplash.com/photo-1653978787896-0cf89060a3bf?w=800&h=600&fit=crop',
      gallery: [
        'https://images.unsplash.com/photo-1704303866732-93723c5325a4?w=800&h=600&fit=crop',
        'https://images.unsplash.com/photo-1567705781486-b5671cb2f27d?w=800&h=600&fit=crop',
      ],
      status: 'Endangered',
      distance: '4,000 km',
      description: 'Iconic anadromous fish that returns from the ocean to its natal river to spawn.',
      seasons: { depart: 'Spring', arrive: 'Summer', return: 'One-way' },
      tips: 'Scottish Highlands and Norwegian rivers for spectacular salmon runs.',
      route: [
        { lat: 62.0, lng: -40.0, name: 'West Greenland Feeding' },
        { lat: 64.0, lng: -25.0, name: 'Faroe Islands' },
        { lat: 60.0, lng: -3.0, name: 'Norwegian Sea' },
        { lat: 57.0, lng: -5.0, name: 'Scottish Rivers' },
        { lat: 54.0, lng: -8.0, name: 'Irish Rivers' },
      ],
      color: '#E88D8D'
    },
    {
      id: 'scalloped-hammerhead',
      name: 'Scalloped Hammerhead Shark',
      scientificName: 'Sphyrna lewini',
      category: 'marine',
      icon: '🦈',
      image: 'https://images.unsplash.com/photo-1709494550287-b4cb3c25518e?w=800&h=600&fit=crop',
      gallery: [
        'https://images.unsplash.com/photo-1637380781238-9b703b0d2db0?w=800&h=600&fit=crop',
        'https://images.unsplash.com/photo-1544552866-49ce864ff896?w=800&h=600&fit=crop',
      ],
      status: 'Critically Endangered',
      distance: '1,200 km',
      description: 'Distinctive hammer-shaped head, forms massive schools at oceanic seamounts.',
      seasons: { depart: 'Variable', arrive: 'Variable', return: 'Variable' },
      tips: 'Cocos Island, Costa Rica and Galápagos for schooling hammerhead encounters.',
      route: [
        { lat: 5.5, lng: -87.0, name: 'Cocos Island' },
        { lat: 1.0, lng: -89.0, name: 'Galápagos Islands' },
        { lat: -1.0, lng: -81.0, name: 'Malpelo Island' },
        { lat: 8.0, lng: -83.0, name: 'Costa Rican Coast' },
      ],
      color: '#546E7A'
    },
  ],
  insects: [
    {
      id: 'monarch-butterfly',
      name: 'Monarch Butterfly',
      scientificName: 'Danaus plexippus',
      category: 'insects',
      icon: '🦋',
      image: 'https://images.unsplash.com/photo-1534198601173-4de3342a0b62?w=800&h=600&fit=crop',
      gallery: [
        'https://images.unsplash.com/photo-1670015451934-d294121cac47?w=800&h=600&fit=crop',
        'https://images.unsplash.com/photo-1566221131703-6605366da599?w=800&h=600&fit=crop',
      ],
      status: 'Endangered',
      distance: '4,800 km',
      description: 'Multi-generational migration spanning continents.',
      seasons: { depart: 'October', arrive: 'November', return: 'March' },
      tips: 'Visit Michoacán, Mexico in winter for millions of monarchs.',
      route: [
        { lat: 45.0, lng: -93.0, name: 'Upper Midwest USA' },
        { lat: 38.0, lng: -95.0, name: 'Kansas' },
        { lat: 32.0, lng: -100.0, name: 'Texas' },
        { lat: 25.0, lng: -102.0, name: 'Northern Mexico' },
        { lat: 19.5, lng: -100.0, name: 'Michoacán Sanctuary' },
      ],
      color: '#F97316'
    },
    {
      id: 'painted-lady',
      name: 'Painted Lady Butterfly',
      scientificName: 'Vanessa cardui',
      category: 'insects',
      icon: '🦋',
      image: 'https://images.unsplash.com/photo-1670015451934-d294121cac47?w=800&h=600&fit=crop',
      gallery: [
        'https://images.unsplash.com/photo-1534198601173-4de3342a0b62?w=800&h=600&fit=crop',
        'https://images.unsplash.com/photo-1566221131703-6605366da599?w=800&h=600&fit=crop',
      ],
      status: 'Least Concern',
      distance: '15,000 km',
      description: 'Longest known insect migration, Africa to Arctic.',
      seasons: { depart: 'Spring', arrive: 'Summer', return: 'Fall' },
      tips: 'Watch European meadows in late spring for mass arrivals.',
      route: [
        { lat: 15.0, lng: 0.0, name: 'Sub-Saharan Africa' },
        { lat: 28.0, lng: -10.0, name: 'Morocco' },
        { lat: 37.0, lng: -5.0, name: 'Spain' },
        { lat: 48.0, lng: 2.0, name: 'France' },
        { lat: 55.0, lng: -3.0, name: 'UK' },
        { lat: 65.0, lng: 15.0, name: 'Scandinavia' },
      ],
      color: '#FB923C'
    },
    {
      id: 'globe-skimmer',
      name: 'Globe Skimmer Dragonfly',
      scientificName: 'Pantala flavescens',
      category: 'insects',
      icon: '🪰',
      image: 'https://images.unsplash.com/photo-1693877906522-8e902374626d?w=800&h=600&fit=crop',
      gallery: [
        'https://images.unsplash.com/photo-1566428484192-180db41644db?w=800&h=600&fit=crop',
        'https://images.unsplash.com/photo-1716516456702-d2959ea54565?w=800&h=600&fit=crop',
      ],
      status: 'Least Concern',
      distance: '18,000 km',
      description: 'The longest migration of any insect across oceans.',
      seasons: { depart: 'October', arrive: 'December', return: 'May' },
      tips: 'Maldives in October for spectacular swarm arrivals.',
      route: [
        { lat: 12.0, lng: 79.0, name: 'India' },
        { lat: 5.0, lng: 73.0, name: 'Maldives' },
        { lat: -5.0, lng: 55.0, name: 'Seychelles' },
        { lat: -12.0, lng: 45.0, name: 'East Africa' },
      ],
      color: '#84CC16'
    },
    {
      id: 'desert-locust',
      name: 'Desert Locust',
      scientificName: 'Schistocerca gregaria',
      category: 'insects',
      icon: '🦗',
      image: 'https://images.unsplash.com/photo-1716516456702-d2959ea54565?w=800&h=600&fit=crop',
      gallery: [
        'https://images.unsplash.com/photo-1693877906522-8e902374626d?w=800&h=600&fit=crop',
        'https://images.unsplash.com/photo-1566428484192-180db41644db?w=800&h=600&fit=crop',
      ],
      status: 'Least Concern',
      distance: '4,500 km',
      description: 'Devastating swarms that crossed the Atlantic Ocean in 1988.',
      seasons: { depart: 'Variable', arrive: 'Variable', return: 'Variable' },
      tips: 'Sahel region during rainy season; swarms follow rains.',
      route: [
        { lat: 25.0, lng: -10.0, name: 'Western Sahara' },
        { lat: 20.0, lng: 0.0, name: 'Sahel Region' },
        { lat: 15.0, lng: 30.0, name: 'Sudan' },
        { lat: 10.0, lng: 45.0, name: 'Horn of Africa' },
        { lat: 20.0, lng: 55.0, name: 'Arabian Peninsula' },
      ],
      color: '#65A30D'
    },
    {
      id: 'bogong-moth',
      name: 'Bogong Moth',
      scientificName: 'Agrotis infusa',
      category: 'insects',
      icon: '🦋',
      image: 'https://images.unsplash.com/photo-1564712564108-981afa2bc79a?w=800&h=600&fit=crop',
      gallery: [
        'https://images.unsplash.com/photo-1534198601173-4de3342a0b62?w=800&h=600&fit=crop',
        'https://images.unsplash.com/photo-1670015451934-d294121cac47?w=800&h=600&fit=crop',
      ],
      status: 'Endangered',
      distance: '1,000 km',
      description: 'Migrates to alpine caves in summer to escape heat, vital Aboriginal food source.',
      seasons: { depart: 'September', arrive: 'November', return: 'February' },
      tips: 'Australian Alps caves in summer; witness emergence at dusk.',
      route: [
        { lat: -32.0, lng: 148.0, name: 'Western Plains NSW' },
        { lat: -34.0, lng: 149.0, name: 'Central NSW' },
        { lat: -35.5, lng: 148.5, name: 'Snowy Mountains' },
        { lat: -36.5, lng: 148.3, name: 'Mt. Bogong Caves' },
      ],
      color: '#A78BFA'
    },
    {
      id: 'green-darner',
      name: 'Green Darner Dragonfly',
      scientificName: 'Anax junius',
      category: 'insects',
      icon: '🪰',
      image: 'https://images.unsplash.com/photo-1566428484192-180db41644db?w=800&h=600&fit=crop',
      gallery: [
        'https://images.unsplash.com/photo-1693877906522-8e902374626d?w=800&h=600&fit=crop',
        'https://images.unsplash.com/photo-1564712564108-981afa2bc79a?w=800&h=600&fit=crop',
      ],
      status: 'Least Concern',
      distance: '1,400 km',
      description: 'North America\'s most common migratory dragonfly, follows bird flyways.',
      seasons: { depart: 'September', arrive: 'November', return: 'April' },
      tips: 'Watch coastal areas during fall hawk migration for swarms.',
      route: [
        { lat: 45.0, lng: -85.0, name: 'Great Lakes Region' },
        { lat: 40.0, lng: -80.0, name: 'Mid-Atlantic USA' },
        { lat: 35.0, lng: -78.0, name: 'North Carolina' },
        { lat: 28.0, lng: -82.0, name: 'Florida' },
        { lat: 23.0, lng: -82.0, name: 'Cuba/Caribbean' },
      ],
      color: '#22D3EE'
    },
    {
      id: 'cloudless-sulphur',
      name: 'Cloudless Sulphur Butterfly',
      scientificName: 'Phoebis sennae',
      category: 'insects',
      icon: '🦋',
      image: 'https://images.unsplash.com/photo-1566221131703-6605366da599?w=800&h=600&fit=crop',
      gallery: [
        'https://images.unsplash.com/photo-1534198601173-4de3342a0b62?w=800&h=600&fit=crop',
        'https://images.unsplash.com/photo-1670015451934-d294121cac47?w=800&h=600&fit=crop',
      ],
      status: 'Least Concern',
      distance: '1,500 km',
      description: 'Bright yellow butterfly that forms mass migrations across the southeastern United States each fall.',
      seasons: { depart: 'August', arrive: 'October', return: 'Spring' },
      tips: 'Florida and Gulf Coast in autumn for spectacular yellow swarms along beaches.',
      route: [
        { lat: 35.0, lng: -85.0, name: 'Southeastern US' },
        { lat: 32.0, lng: -84.0, name: 'Georgia' },
        { lat: 29.0, lng: -82.0, name: 'Northern Florida' },
        { lat: 25.5, lng: -80.5, name: 'South Florida' },
        { lat: 22.0, lng: -79.5, name: 'Cuba/Caribbean' },
      ],
      color: '#FACC15'
    },
  ],
  reptiles: [
    {
      id: 'green-sea-turtle',
      name: 'Green Sea Turtle',
      scientificName: 'Chelonia mydas',
      category: 'reptiles',
      icon: '🐢',
      image: 'https://images.unsplash.com/photo-1574248265178-622da6d65714?w=800&h=600&fit=crop',
      gallery: [
        'https://images.unsplash.com/photo-1633883494580-5cd8d8c45207?w=800&h=600&fit=crop',
        'https://images.unsplash.com/photo-1545559041-1959e2df2747?w=800&h=600&fit=crop',
      ],
      status: 'Endangered',
      distance: '2,600 km',
      description: 'Returns to the exact beach where it was born to lay eggs.',
      seasons: { depart: 'Year-round', arrive: 'Varies', return: 'Varies' },
      tips: 'Tortuguero, Costa Rica for nesting; Great Barrier Reef for feeding.',
      route: [
        { lat: -23.5, lng: 152.0, name: 'Great Barrier Reef' },
        { lat: -18.0, lng: 148.0, name: 'Coral Sea' },
        { lat: -12.0, lng: 143.0, name: 'Torres Strait' },
        { lat: -11.5, lng: 143.0, name: 'Raine Island Nesting' },
      ],
      color: '#15803D'
    },
    {
      id: 'loggerhead-turtle',
      name: 'Loggerhead Sea Turtle',
      scientificName: 'Caretta caretta',
      category: 'reptiles',
      icon: '🐢',
      image: 'https://images.unsplash.com/photo-1633940836680-53d33a74e0db?w=800&h=600&fit=crop',
      gallery: [
        'https://images.unsplash.com/photo-1574248265178-622da6d65714?w=800&h=600&fit=crop',
        'https://images.unsplash.com/photo-1743613338981-6f4ddc07f9dc?w=800&h=600&fit=crop',
      ],
      status: 'Vulnerable',
      distance: '12,000 km',
      description: 'Trans-Pacific journeys from Japan to Mexico and back.',
      seasons: { depart: 'Year-round', arrive: 'Varies', return: 'Varies' },
      tips: 'Japanese beaches May-August for nesting season.',
      route: [
        { lat: 33.0, lng: 135.0, name: 'Japan Nesting Beaches' },
        { lat: 35.0, lng: 160.0, name: 'North Pacific Current' },
        { lat: 30.0, lng: 220.0, name: 'Central Pacific' },
        { lat: 25.0, lng: 245.0, name: 'Baja California Feeding' },
      ],
      color: '#92400E'
    },
    {
      id: 'kemps-ridley-turtle',
      name: "Kemp's Ridley Sea Turtle",
      scientificName: 'Lepidochelys kempii',
      category: 'reptiles',
      icon: '🐢',
      image: 'https://images.unsplash.com/photo-1545559041-1959e2df2747?w=800&h=600&fit=crop',
      gallery: [
        'https://images.unsplash.com/photo-1574248265178-622da6d65714?w=800&h=600&fit=crop',
        'https://images.unsplash.com/photo-1633883494580-5cd8d8c45207?w=800&h=600&fit=crop',
      ],
      status: 'Critically Endangered',
      distance: '2,000 km',
      description: 'World\'s most endangered sea turtle, nesting almost exclusively on one beach in Mexico.',
      seasons: { depart: 'Year-round', arrive: 'Varies', return: 'Varies' },
      tips: 'Rancho Nuevo, Tamaulipas, Mexico during the synchronized mass nesting (arribada).',
      route: [
        { lat: 23.5, lng: -97.5, name: 'Rancho Nuevo Nesting Beach' },
        { lat: 26.0, lng: -95.0, name: 'Gulf of Mexico' },
        { lat: 28.0, lng: -90.0, name: 'Louisiana Coast' },
        { lat: 29.0, lng: -85.0, name: 'Florida Panhandle' },
        { lat: 27.0, lng: -83.0, name: 'Tampa Bay Feeding' },
      ],
      color: '#558B2F'
    },
    {
      id: 'hawksbill-turtle',
      name: 'Hawksbill Sea Turtle',
      scientificName: 'Eretmochelys imbricata',
      category: 'reptiles',
      icon: '🐢',
      image: 'https://images.unsplash.com/photo-1743613338981-6f4ddc07f9dc?w=800&h=600&fit=crop',
      gallery: [
        'https://images.unsplash.com/photo-1633940836680-53d33a74e0db?w=800&h=600&fit=crop',
        'https://images.unsplash.com/photo-1574248265178-622da6d65714?w=800&h=600&fit=crop',
      ],
      status: 'Critically Endangered',
      distance: '2,400 km',
      description: 'Essential for coral reef health, with a beautiful overlapping shell pattern.',
      seasons: { depart: 'Year-round', arrive: 'Varies', return: 'Varies' },
      tips: 'Maldives, Caribbean reefs, and Seychelles for snorkeling encounters.',
      route: [
        { lat: 21.0, lng: -86.5, name: 'Yucatan Nesting Beaches' },
        { lat: 18.0, lng: -78.0, name: 'Jamaica' },
        { lat: 15.0, lng: -70.0, name: 'Caribbean Sea' },
        { lat: 12.0, lng: -62.0, name: 'Barbados' },
        { lat: 10.0, lng: -58.0, name: 'Trinidad Feeding Grounds' },
      ],
      color: '#BF360C'
    },
  ],
  crustaceans: [
    {
      id: 'christmas-island-red-crab',
      name: 'Christmas Island Red Crab',
      scientificName: 'Gecarcoidea natalis',
      category: 'crustaceans',
      icon: '🦀',
      image: 'https://images.unsplash.com/photo-1676910914217-5921ead9a392?w=800&h=600&fit=crop',
      gallery: [
        'https://images.unsplash.com/photo-1676215705742-f2f1454d5c0d?w=800&h=600&fit=crop',
        'https://images.unsplash.com/photo-1559548331-f9cb98001426?w=800&h=600&fit=crop',
      ],
      status: 'Least Concern',
      distance: '8 km',
      description: '120 million crabs march from forest to ocean - largest land crab migration.',
      seasons: { depart: 'October', arrive: 'November', return: 'December' },
      tips: 'Christmas Island, Australia during wet season for the spectacular march.',
      route: [
        { lat: -10.45, lng: 105.65, name: 'Central Plateau Forest' },
        { lat: -10.48, lng: 105.60, name: 'Migration Routes' },
        { lat: -10.50, lng: 105.55, name: 'Coastal Terraces' },
        { lat: -10.52, lng: 105.50, name: 'Ocean Spawning Beaches' },
      ],
      color: '#DC2626'
    },
    {
      id: 'chinese-mitten-crab',
      name: 'Chinese Mitten Crab',
      scientificName: 'Eriocheir sinensis',
      category: 'crustaceans',
      icon: '🦀',
      image: 'https://images.unsplash.com/photo-1676215705742-f2f1454d5c0d?w=800&h=600&fit=crop',
      gallery: [
        'https://images.unsplash.com/photo-1676910914217-5921ead9a392?w=800&h=600&fit=crop',
        'https://images.unsplash.com/photo-1559548331-f9cb98001426?w=800&h=600&fit=crop',
      ],
      status: 'Least Concern',
      distance: '1,500 km',
      description: 'Spends years in rivers then migrates to ocean to spawn.',
      seasons: { depart: 'Autumn', arrive: 'Winter', return: 'Spring (juveniles)' },
      tips: 'Yangtze River delta in China during autumn migration.',
      route: [
        { lat: 32.0, lng: 119.0, name: 'Upper Yangtze River' },
        { lat: 31.5, lng: 120.0, name: 'Middle Reaches' },
        { lat: 31.2, lng: 121.0, name: 'Yangtze Delta' },
        { lat: 31.0, lng: 122.0, name: 'East China Sea Spawning' },
      ],
      color: '#7C3AED'
    },
  ]
};

// Flatten all species for easy access
export const allSpecies = [
  ...speciesData.birds,
  ...speciesData.mammals,
  ...speciesData.marine,
  ...speciesData.insects,
  ...speciesData.reptiles,
  ...speciesData.crustaceans
];

// --- CATEGORY ICONS ---
export const categoryConfig = {
  birds: { icon: '🐦', label: 'Birds', color: '#3B82F6' },
  mammals: { icon: '🦁', label: 'Mammals', color: '#A16207' },
  marine: { icon: '🌊', label: 'Marine', color: '#0EA5E9' },
  insects: { icon: '🦋', label: 'Insects', color: '#F97316' },
  reptiles: { icon: '🐢', label: 'Reptiles', color: '#15803D' },
  crustaceans: { icon: '🦀', label: 'Crustaceans', color: '#DC2626' }
};
